import { DrawingCandidatesListConfig } from '@app/routes/index/pending-drawings/_models';

// One action per step: each patches only its own bucket, so a step cannot erase another's filters.
export class SetDrawingCandidatesInReviewListConfig {
  static readonly type = '[Drawing Candidates In Review] Set List Config';
  constructor(public config: DrawingCandidatesListConfig) {}
}

export class SetDrawingCandidatesInMatchListConfig {
  static readonly type = '[Drawing Candidates In Match] Set List Config';
  constructor(public config: DrawingCandidatesListConfig) {}
}
